export const JWT_COOKIE_NAME = "ncms_c360_jwt";
export const JWT_COOKIE_SAMESITE = "Lax";
export const API_SECRET_KEY = "xeJJzhaj1mQ-ksTB_nF_iH0z5YdG50yQtwQCzbcHuKA";
export const PUSHER_APP_ID = "1331970";
export const PUSHER_KEY = "88daedd0895b458ce312";
export const PUSHER_SECRET = "f9fb7e5f52cadd9a3522";
export const PUSHER_CLUSTER = "ap2";
export const USER_DATA_URL = "/api/1/auth/user/";
export const GA_TRACKING_ID = "UA-46098128-1";
export const GTM_TRACKING_ID = "GTM-NBBD8P";
export const CLEVERTAP_TRACKING_ID = "654-ZZ4-5Z5Z";
export const BROWSEE_ID = "85f6c252448a9a80b5d512130513f2c507ab713b6fc9b432";
export const AUTH_REDIRECT = [
  {
    route: "/cms",
    redirect: "/cms/login/",
  },
];
